import React from "react";
import { Mutation } from "react-apollo";
import Button from "@streeteasy/design-system/deprecated/Button";
import Input from "@streeteasy/design-system/deprecated/Input";
import Text from "@streeteasy/design-system/deprecated/Text";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { func, object, shape, string } from "prop-types";

import GlobalState from "../../../../../../../shared/utilities/globalState";
import { passwordRequestedGA } from "../../../../analytics/ga";
import LOGIN from "../../../../mutations/login";
import {
  ModalButton,
  ModalHeading,
  ModalInput,
  ModalText,
  ModalTitle,
  SecondaryPasswordButton,
  TextBold,
  XButtonWrapper
} from "../../styled";

class PasswordRequested extends React.Component {
  static defaultProps = {
    formError: ""
  };

  static propTypes = {
    form: shape({
      data: object,
      email: string,
      password: string
    }).isRequired,
    formError: string,
    handleCloseModal: func.isRequired,
    handleCreateBoundary: func.isRequired,
    handleInputChange: func.isRequired,
    handleMutationError: func.isRequired,
    handleRedirectTo: func.isRequired,
    handleRenderError: func.isRequired,
    setScenario: func.isRequired
  };

  // GA starts
  componentDidMount() {
    this.analyticsData = JSON.parse(localStorage.getItem("analytics")) || "";
    const { flow, source, userId, userType } = this.analyticsData;
    passwordRequestedGA.enterPasswordModalOpens(source, flow, userType, userId);
  }
  // GA ends

  handleCompletedLogin = data => {
    if (
      typeof this.props.form.data.boundary === "object" &&
      data.login.__typename === "LoginResult"
    ) {
      GlobalState.registerCallback("login", this.props.handleCreateBoundary);
    }

    if (data.login.is_unverified_industry) {
      this.props.setScenario("RegisterIndustryConfirmation", {
        email: this.props.form.email
      });
    } else if (GlobalState.hasCallbacks("login")) {
      GlobalState.runCallbacks("login");
      this.props.handleCloseModal();
    } else {
      this.props.handleRedirectTo(this.props.form.data.redirectTo);
    }

    // GA starts
    const { flow, source } = this.analyticsData;

    passwordRequestedGA.enterPasswordModalSubmit(source, flow);
    // GA ends
  };

  handleSubmitLogin = mutationQuery => {
    mutationQuery({
      variables: {
        data: JSON.stringify(this.props.form.data),
        email: this.props.form.email,
        password: this.props.form.password
      }
    });
  };

  render() {
    const { handleMutationError } = this.props;

    return (
      <div>
        <ModalHeading>
          <ModalTitle type="primarySm">Enter your password</ModalTitle>
          <XButtonWrapper>
            <XButton onClick={this.props.handleCloseModal} />
          </XButtonWrapper>
        </ModalHeading>
        <ModalText>
          <Text type="sm">
            Welcome back,&nbsp;
            <TextBold as="span" type="sm">
              {this.props.form.email}
            </TextBold>
          </Text>
        </ModalText>
        <Mutation
          mutation={LOGIN}
          onCompleted={this.handleCompletedLogin}
          onError={handleMutationError}
        >
          {mutationQuery => (
            <form
              onSubmit={e => {
                this.handleSubmitLogin(mutationQuery);
                e.preventDefault();
              }}
            >
              <ModalInput>
                <Input
                  autoFocus
                  isInvalid={this.props.formError}
                  name="password"
                  onChange={this.props.handleInputChange}
                  placeholder="Password"
                  type="password"
                />
              </ModalInput>
              {this.props.handleRenderError()}
              <ModalButton>
                <Button theme="primary" type="submit">
                  Log in
                </Button>
              </ModalButton>
            </form>
          )}
        </Mutation>
        <SecondaryPasswordButton>
          <TextLink
            href="#"
            onClick={() => this.props.setScenario("ResetPassword")}
          >
            Forgot Your Password?
          </TextLink>
        </SecondaryPasswordButton>
      </div>
    );
  }
}

export default PasswordRequested;
